import { render, staticRenderFns } from "./TefConfig.vue?vue&type=template&id=10cef5dd"
import script from "./TefConfig.vue?vue&type=script&lang=js"
export * from "./TefConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10cef5dd')) {
      api.createRecord('10cef5dd', component.options)
    } else {
      api.reload('10cef5dd', component.options)
    }
    module.hot.accept("./TefConfig.vue?vue&type=template&id=10cef5dd", function () {
      api.rerender('10cef5dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/tef/TefConfig.vue"
export default component.exports